// extracted by mini-css-extract-plugin
export var productImage = "_ms-1";
export var viewLink = "_ms-2";
export var wishlistItem = "_ms-0";